<template>
    <form id="payment-form" @submit.prevent="pay">
        <div id="card-element"></div>
        <button id="submit" :disabled="isSubmitting">
            <div class="spinner" id="spinner" :class="{ hidden: !isSubmitting }"></div>
            <span id="button-text" :class="{ hidden: isSubmitting }">Pay now</span>
        </button>
        <p id="card-error" role="alert">{{ cardError }}</p>
        <p class="result-message" :class="{ hidden: !paymentSucceeded }">
            Payment succeeded, see the result in your
            <a href="" target="_blank">Stripe dashboard.</a> Refresh the page to pay again.

        </p>
    </form>
</template>
<script>
import { ref } from 'vue';
import { loadStripe } from '@stripe/stripe-js';

export default {
    name: 'PaymentForm',

    data() {
        return {
            stripe: null,
            card: null,
            clientSecret: null,
            isSubmitting: false,
            cardError: '',
            paymentSucceeded: false,
        };
    },

    mounted() {
        this.initStripe();
    },

    methods: {
        initStripe() {
            const stripePromise = loadStripe(racingstars.env('STRIPE_KEY'));
            stripePromise.then(stripe => {
                this.stripe = stripe;

                const elements = stripe.elements();
                const style = {
                    base: {
                        color: "#32325d",
                        fontFamily: 'Arial, sans-serif',
                        fontSmoothing: "antialiased",
                        fontSize: "16px",
                        "::placeholder": {
                            color: "#32325d"
                        }
                    },
                    invalid: {
                        fontFamily: 'Arial, sans-serif',
                        color: "#fa755a",
                        iconColor: "#fa755a"
                    }
                };
                this.card = elements.create("card", { style: style });
                this.card.mount("#card-element");
                this.card.on("change", event => {
                    this.cardError = event.error ? event.error.message : '';
                });
            });
        },

        pay() {
            this.isSubmitting = true;
            this.stripe.confirmCardPayment(this.clientSecret, {
                payment_method: {
                    card: this.card,
                }
            }).then(result => {
                this.isSubmitting = false;
                if (result.error) {
                    this.cardError = result.error.message;
                } else {
                    this.paymentSucceeded = true;
                    this.orderComplete(result.paymentIntent.id);
                }
            });
        },

        orderComplete(paymentIntentId) {
            this.$refs.resultMessage.querySelector('a').setAttribute('href', `https://dashboard.stripe.com/payments/${paymentIntentId}`);
            this.$refs.resultMessage.classList.remove('hidden');
            this.$refs.submit.disabled = true;
        },
    },
};
</script>
